<ng-container *ngIf="model">
    <ms-day-of-race-lobby *ngIf="model.fixtures.length" [dayOfRace]="model" [filter]="day" [sportId]="sportId"></ms-day-of-race-lobby>
    <ms-greyhounds-error-breadcrumb *ngIf="!model.fixtures.length">
        <ms-error item-header [links]="false" [message]="errorMessage" [severity]="'info'"></ms-error>
    </ms-greyhounds-error-breadcrumb>
</ng-container>
